import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/AdminLayout/AdminLayout';
import Pagination from '../../components/Pagination/Pagination';
import './ProjectManagePage.css';

const ProjectManagePage = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const projects = [
    { id: 1, title: 'Downtown Commercial Complex', company: 'Gulf Building Supplies', location: 'Dubai, UAE', budget: '$2.5M', deadline: '15.06.2026', status: 'Active' },
    { id: 2, title: 'Residential Tower Phase 2', company: 'ABC Construction Co', location: 'Abu Dhabi, UAE', budget: '$4.2M', deadline: '20.08.2026', status: 'Active' },
    { id: 3, title: 'Industrial Warehouse Project', company: 'Elite Materials Trading', location: 'Sharjah, UAE', budget: '$800K', deadline: '10.03.2026', status: 'Pending' },
    { id: 4, title: 'Shopping Mall Renovation', company: 'Modern Build Solutions', location: 'Riyadh, SA', budget: '$1.8M', deadline: '25.05.2026', status: 'Active' },
    { id: 5, title: 'Hospital Extension Wing', company: 'Quality Contractors LLC', location: 'Doha, Qatar', budget: '$6.5M', deadline: '30.12.2026', status: 'Inactive' },
    { id: 6, title: 'Office Building Construction', company: 'Prime Construction Group', location: 'Kuwait City', budget: '$3.1M', deadline: '15.09.2026', status: 'Active' },
  ];

  const handleSelectItem = (id) => {
    setSelectedItems(prev => 
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  return (
    <AdminLayout>
      <div className="project-manage-content">
        <div className="pm-page-header">
          <div className="pm-page-title-section">
            <h1 className="pm-page-title">Project Management</h1>
            <p className="pm-page-description">View and manage all construction projects.</p>
          </div>
          <button className="pm-add-btn" onClick={() => navigate('/project-input')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M12 5V19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Add Project</span>
          </button>
        </div>

        <div className="pm-content">
          <div className="pm-list-header">
            <h2 className="pm-list-title">All Projects ({projects.length})</h2>
            <div className="pm-list-controls">
              <div className="pm-search-box">
                <input 
                  type="text" 
                  placeholder="Search projects..." 
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <circle cx="9.16667" cy="9.16667" r="5.83333" stroke="#969696" strokeWidth="1.5"/>
                  <path d="M14.166 14.1665L17.4993 17.4998" stroke="#969696" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
              <div className="pm-dropdown">
                <span>Status</span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M5 7.5L10 12.5L15 7.5" stroke="#6D6D6D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="pm-dropdown">
                <span>Location</span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M5 7.5L10 12.5L15 7.5" stroke="#6D6D6D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          </div>

          <div className="pm-table">
            <div className="pm-table-header">
              <div className="pm-th pm-th-checkbox">
                <input type="checkbox" />
              </div>
              <div className="pm-th">Project Title</div>
              <div className="pm-th">Company</div>
              <div className="pm-th">Location</div>
              <div className="pm-th">Budget</div>
              <div className="pm-th">Deadline</div>
              <div className="pm-th">Status</div>
              <div className="pm-th">Action</div>
            </div>
            <div className="pm-table-body">
              {projects.map((project) => (
                <div key={project.id} className="pm-table-row">
                  <div className="pm-td pm-td-checkbox">
                    <input 
                      type="checkbox" 
                      checked={selectedItems.includes(project.id)}
                      onChange={() => handleSelectItem(project.id)}
                    />
                  </div>
                  <div className="pm-td pm-td-title">{project.title}</div>
                  <div className="pm-td">{project.company}</div>
                  <div className="pm-td">{project.location}</div>
                  <div className="pm-td pm-td-budget">{project.budget}</div>
                  <div className="pm-td">{project.deadline}</div>
                  <div className="pm-td">
                    <span className={`pm-status-badge ${project.status.toLowerCase()}`}>{project.status}</span>
                  </div>
                  <div className="pm-td pm-td-action">
                    <button className="pm-view-btn">View</button>
                    <button className="pm-edit-btn">Edit</button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <Pagination currentPage={currentPage} totalPages={3} onPageChange={setCurrentPage} />
        </div>
      </div>
    </AdminLayout>
  );
};

export default ProjectManagePage;
